import { createFileRoute, redirect } from "@tanstack/react-router";
import { Role } from "@/core/components/auth/auth.types";
import { LoadingList } from "@/core/components/LoadingList";
import { getRoomBlockById } from "@/core/components/sites/site/room-blocks/roomBlocksQueryOptions";

export const Route = createFileRoute(
	"/_layout/dashboard/sites/$siteId/room-blocks/$roomBlockId/",
)({
	beforeLoad: ({ context: { auth } }) => {
		if (auth.isExpired()) {
			return;
		}
		if (!auth.isAuthenticated) {
			throw redirect({
				to: "/",
			});
		}
		if (
			auth.user?.role === Role["Front-Desk"] ||
			auth.user?.role === Role["Blogger"]
		) {
			throw redirect({
				to: "/dashboard",
			});
		}
	},
	loader: ({ context: { queryClient, auth }, params }) => {
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		queryClient.ensureQueryData(
			getRoomBlockById(params.siteId, auth.token!, params.roomBlockId),
		);
	},
	pendingComponent: LoadingList,
});
